import { CSSProperties } from 'react';

export const isHebrewOrArabicText = (text: string): boolean => {
   // Hebrew Unicode range: 0590-05FF
  // Arabic Unicode range: 0600-06FF, 0750-077F (Arabic Supplement), 08A0-08FF (Arabic Extended-A)
  const rtlPattern = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  return rtlPattern.test(text);
};

export const getCommentStyle = (text: string): CSSProperties => {
  return isHebrewOrArabicText(text) ? { direction: 'rtl' as const, textAlign: 'right' as const } : {};
};